import { render, staticRenderFns } from "./AccessPolicyOperantSelect.vue?vue&type=template&id=533659a8&"
import script from "./AccessPolicyOperantSelect.vue?vue&type=script&lang=ts&"
export * from "./AccessPolicyOperantSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports